export default function CustomHeaders( { headers, onChange } ) {
	const addRow    = () => onChange( [ ...headers, { name: '', value: '' } ] );
	const removeRow = ( i ) => onChange( headers.filter( ( _, idx ) => idx !== i ) );
	const updateRow = ( i, key, val ) =>
		onChange( headers.map( ( row, idx ) => ( idx === i ? { ...row, [ key ]: val } : row ) ) );

	return (
		<div className="rtwc-section">
			<p className="description rtwc-section-desc">
				Add custom HTTP headers to be sent with each webhook request (e.g. Authorization tokens).
			</p>

			{ headers.length > 0 ? (
				<table className="wp-list-table widefat striped rtwc-mapping-table">
					<thead>
						<tr>
							<th>Header Name</th>
							<th>Header Value</th>
							<th style={ { width: 80 } }></th>
						</tr>
					</thead>
					<tbody>
						{ headers.map( ( row, i ) => (
							<tr key={ i }>
								<td>
									<input
										type="text"
										className="regular-text"
										value={ row.name }
										placeholder="e.g. Authorization"
										onChange={ ( e ) => updateRow( i, 'name', e.target.value ) }
									/>
								</td>
								<td>
									<input
										type="text"
										className="regular-text"
										value={ row.value }
										placeholder="e.g. Bearer token123"
										onChange={ ( e ) => updateRow( i, 'value', e.target.value ) }
									/>
								</td>
								<td>
									<button
										type="button"
										className="button rtwc-remove-btn"
										onClick={ () => removeRow( i ) }
										title="Remove header"
									>
										✕
									</button>
								</td>
							</tr>
						) ) }
					</tbody>
				</table>
			) : (
				<div className="rtwc-empty-table">
					<em>No custom headers – Content-Type: application/json is always included.</em>
				</div>
			) }

			<p>
				<button type="button" className="button button-secondary" onClick={ addRow }>
					+ Add Header
				</button>
			</p>
		</div>
	);
}
